export enum RoleType {
  Vendor = 'VENDOR',
  Customer = 'CUSTOMER',
}
export interface Role {
  roleId: number;
  roleName: string;
  roleDescription?: string;
  usedByPartners?: boolean;
  type: RoleType;
}
